import { baseUrl } from "../../constants";

const dummyMembers = [
  {
    photoUrl: `/image/4th-year-profile-photos/Parveen.jpg`,
    Name: "Parveen Kumar",
    Position: "Secretary",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Kashish.jpg`,
    Name: "Kashish Garg",
    Position: "Secretary",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Umang.jpg`,
    Name: "Umang Jain",
    Position: "Sponsorship Secretary",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Roneet.jpg`,
    Name: "Roneet Kumar Singh",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Ankit.jpg`,
    Name: "Ankit",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Muskan Agrawal.jpg`,
    Name: "Muskan Agrawal",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Pragya.jpg`,
    Name: "Pragya Dass",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Ishika.jpg`,
    Name: "Ishika",
    Position: "Committee Head",
    About: "",
  },

  {
    photoUrl: `/image/4th-year-profile-photos/Shivnath.jpg`,
    Name: "Shivnath",
    Position: "Committee Head",
    About: "",
  },

  {
    photoUrl: `/image/4th-year-profile-photos/Vipul.jpg`,
    Name: "Vipul",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Sourabh.jpg`,
    Name: "Sourabh",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Sonu.jpg`,
    Name: "Sonu",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Vishakha.jpg`,
    Name: "Vishakha Bagadi",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Krishan.jpg`,
    Name: "Krishan Kumar ",
    Position: "Committee Head",
    About: "",
  },

  {
    photoUrl: `/image/4th-year-profile-photos/Shubham.jpg`,
    Name: "Shubham kumar",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Divyansh.jpg`,
    Name: "Divyansh",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Varsha.jpg`,
    Name: "Varsha Sharma ",
    Position: "Committee Head",
    About: "",
  },
  {
    photoUrl: `/image/4th-year-profile-photos/Arpit.jpg`,
    Name: "Arpit",
    Position: "Committee Head",
    About: "",
  },

  {
    photoUrl: `/image/4th-year-profile-photos/Aryan.png`,
    Name: "Aryan Kabra",
    Position: "Committee Head",
    About: "",
  },
];

const dummyYoutubeUrls = [
  "https://www.youtube.com/watch?v=ovBkVxi057Q",
  "https://www.youtube.com/watch?v=3RD1vS7jqF0",
  "https://www.youtube.com/watch?v=xQAM8b-OKmw",
  "https://www.youtube.com/watch?v=e1kIYQNaIF4",
  "https://www.youtube.com/watch?v=pJ3khRoqLf0",
  "https://www.youtube.com/watch?v=SqdVpP60dek",
];

const hladReviews = [
  {
    photoUrl: `/image/third.jpg`,
    nameAndDetail: "Hardeep , batch 2019",
    review:
      "These six weeks have been full of learnings – from trying to find a problem and then attempting to solve it, from knowing nothing about something to coming up with a full-fledged project. For all I know is, it would have been impossible for me to do all of this without a team. Everything Crework have done for the community is so inspiring - from bringing people together to putting umpteen efforts to help them do well in their lives.&nbsp;",
  },
  {
    photoUrl: `/image/third.jpg`,
    nameAndDetail: "Hardeep , batch 2019",
    review:
      "These six weeks have been full of learnings – from trying to find a problem and then attempting to solve it, from knowing nothing about something to coming up with a full-fledged project. For all I know is, it would have been impossible for me to do all of this without a team. Everything Crework have done for the community is so inspiring - from bringing people together to putting umpteen efforts to help them do well in their lives.&nbsp;",
  },
  {
    photoUrl: `/image/third.jpg`,
    nameAndDetail: "Hardeep , batch 2019",
    review:
      "These six weeks have been full of learnings – from trying to find a problem and then attempting to solve it, from knowing nothing about something to coming up with a full-fledged project. For all I know is, it would have been impossible for me to do all of this without a team. Everything Crework have done for the community is so inspiring - from bringing people together to putting umpteen efforts to help them do well in their lives.&nbsp;",
  },
  {
    photoUrl: `/image/third.jpg`,
    nameAndDetail: "Hardeep , batch 2019",
    review:
      "These six weeks have been full of learnings – from trying to find a problem and then attempting to solve it, from knowing nothing about something to coming up with a full-fledged project. For all I know is, it would have been impossible for me to do all of this without a team. Everything Crework have done for the community is so inspiring - from bringing people together to putting umpteen efforts to help them do well in their lives.&nbsp;",
  },
  {
    photoUrl: `/image/third.jpg`,
    nameAndDetail: "Hardeep , batch 2019",
    review:
      "These six weeks have been full of learnings – from trying to find a problem and then attempting to solve it, from knowing nothing about something to coming up with a full-fledged project. For all I know is, it would have been impossible for me to do all of this without a team. Everything Crework have done for the community is so inspiring - from bringing people together to putting umpteen efforts to help them do well in their lives.&nbsp;",
  },
];

const initial_state = {
  homePageMembers: dummyMembers,
  homePageYoutubeLinks: dummyYoutubeUrls,
  homeWhatCommunitySays: hladReviews,
};

const rootReducer = (state = initial_state, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default rootReducer;
